import Phaser from 'phaser-ce';
import GameObject from './GameObject';
import gameConsts from './gameConsts';

const SHIELD_INCREASE = 1.2;
const SHIELD_ITERATIONS = 4;
const DRIFT_ROTATION_TIME = 1000;
const DRIFT_VELOCITY_TIME = 2000;
const DELTA_VELOCITY = 10;
const DELTA_POINTS = 100;
const DELTA_POWER = 1;
const OFFSET_X = 14;
const OFFSET_Y = 6;
const ANIMATIONS = ['power', 'doublePoints', 'shieldCreate', 'shieldActive'];
const ANIMATIONS_VALUES = {
  power: {
    count: 10,
    loop: false,
  },
  doublePoints: {
    count: 10,
    loop: true,
  },
  shieldCreate: {
    count: 15,
    loop: false,
  },
  shieldActive: {
    count: 8,
    loop: true,
  },
};

export default class Player extends GameObject {
  constructor({ game, road, values }) {
    super({
      game,
      values,
      name: 'player',
    });
    this._defaultDiameter = this.defaultHeight * SHIELD_INCREASE;
    this._road = road;
    this.item = this._game.add.sprite(this._coordX, this._coordY, 'nfs', `${this._name}.png`);
    this._angle = -20;
    this._currentVelocity = values.velocity;
    this._defaultVelocity = values.velocity;
    this._keys = this._game.input.keyboard.createCursorKeys();
    this.controls = {
      left: false,
      right: false,
    };
    ANIMATIONS.forEach((item) => {
      this[`_${item}`] = this._game.add.sprite(-gameConsts.GAME_WIDTH, this._coordY, 'nfs', `animation/${item}/0001.png`);
      this[`_${item}Anim`] = this[`_${item}`].animations.add(item, Phaser.Animation.generateFrameNames(`animation/${item}/`, 1, ANIMATIONS_VALUES[item].count, '.png', 4), 9, ANIMATIONS_VALUES[item].loop, false);
    });
    this._points = this._game.add.sprite(this._coordX, this._coordY, 'nfs', 'points-150.png');
    this._pointsTween = {};
  }
  get _offsetX() {
    return OFFSET_X * this._scaleValue;
  }
  get _offsetY() {
    return OFFSET_Y * this._scaleValue;
  }
  get _defaultArea() {
    return {
      width: this._defaultWidth - (2 * this._offsetX),
      height: this.defaultHeight - this._offsetY,
      diameter: this._defaultDiameter / 2,
      offsetCircleX: -(this._defaultDiameter - this._defaultWidth) / 2,
      offsetCircleY: -(this._defaultDiameter - this.defaultHeight) / 2,
    };
  }
  get _bounds() {
    return this.item.getBounds();
  }
  get _minX() {
    return (this._road.item.position.x + this._road.borderWidth + (2 * this._offsetX)) - this.width;
  }
  get _maxX() {
    return this._minX + this._road.width;
  }
  get _coordX() {
    return this._road.item.position.x + ((this._road.width - this.width) / 2);
  }
  // eslint-disable-next-line
  get _coordY() {
    return gameConsts.GAME_HEIGHT - (gameConsts.GAME_HEIGHT / (4 - this._scaleValue));
  }
  set _isOutOfRoad(val) {
    // торможение при выезде за край дороги
    if (val) {
      this._road.speedDown();
    } else {
      this._road.speedUp();
    }
  }
  _checkShield() {
    this._playerData.isShield = this._shieldActiveAnim.isPlaying || this._shieldCreateAnim.isPlaying;
    if (this._playerData.isShield) {
      this._setCircleArea();
    } else {
      this._setArea();
    }
  }
  _setArea() {
    this.item.body.setSize(this._defaultArea.width, this._defaultArea.height, this._offsetX, this._offsetY);
  }
  _setCircleArea() {
    this.item.body.setCircle(this._defaultArea.diameter, this._defaultArea.offsetCircleX, this._defaultArea.offsetCircleY);
  }
  _animate(item, to, time) {
    this._game.add.tween(item).to(to, time, Phaser.Easing.Cubic.Out, true);
  }
  _checkOutRoad() {
    const boundsRoad = this._road.bounds;
    const boundsPlayer = this._bounds;

    boundsRoad.width -= 2 * this.width;
    boundsRoad.centerX = gameConsts.GAME_WIDTH / 2;

    // если машина вышла за края дороги - игра закончена
    this._isOutOfRoad = !Phaser.Rectangle.intersects(boundsRoad, boundsPlayer);
  }
  _drift() {
    this.item.body.immovable = false;
    if (this.item.body.velocity.x === 0) {
      // врезается сзади
      this.item.body.velocity.y = this._currentVelocity / 2;
    } else {
      // врезается сбоку
      this.item.body.velocity.y = this._currentVelocity / 4;
      this._angle = this.item.body.velocity.x / ((Math.abs(this.item.body.velocity.x) === this._currentVelocity) ? 8 : 1.5);
      this.item.body.velocity.x = (Math.abs(this.item.body.velocity.x) === this._currentVelocity) ? (-this.item.body.velocity.x / 4) : (-this.item.body.velocity.x * 2);
    }
    this._animate(this.item, { angle: this._angle }, DRIFT_ROTATION_TIME);
    this._animate(this.item.body.velocity, { y: 0 }, DRIFT_VELOCITY_TIME);
    this._animate(this.item.body.velocity, { x: 0 }, DRIFT_VELOCITY_TIME);
  }
  _resetVelocity() {
    this.item.body.velocity.x = 0;
    this.item.body.velocity.y = 0;
    this._points.body.velocity.x = 0;
  }
  _moveLeft() {
    if (this.item.position.x >= this._minX) {
      this.item.body.velocity.x = -this._currentVelocity;
    }
  }
  _moveRight() {
    if (this.item.position.x <= this._maxX) {
      this.item.body.velocity.x = this._currentVelocity;
    }
  }
  scaleItem() {
    super.scaleItem();
    this.item.position.x = this._coordX;
    this.item.position.y = this._coordY;
    this._points.scale.setTo(this._scaleValue, this._scaleValue);

    ANIMATIONS.forEach((item) => {
      this[`_${item}`].scale.setTo(this._scaleValue, this._scaleValue);
      this[`_${item}`].centerY = this.item.centerY;
    });
  }
  update() {
    // движение машинки по нажатию на клавиши
    this.item.body.velocity.x = 0;
    if ((this.controls.right || this._keys.right.isDown) && !(this._keys.left.isDown || this.controls.left)) {
      this._moveRight();
    } else if ((this.controls.left || this._keys.left.isDown) && !(this._keys.right.isDown || this.controls.right)) {
      this._moveLeft();
    }
    this._updateAnimations();
    this._checkShield();
    return this._checkOutRoad();
  }
  increaseSpeed() {
    this._currentVelocity += DELTA_VELOCITY;
  }
  create() {
    this._game.physics.enable(this.item, Phaser.Physics.ARCADE);
    this.item.body.collideWorldBounds = true;
    this.item.body.immovable = true;
    this.item.body.bounce.setTo(0.2, 0.2);
    this.item.bringToTop();
    ANIMATIONS.forEach((item) => {
      this._game.physics.enable(this[`_${item}`], Phaser.Physics.ARCADE);
      this[`_${item}`].bringToTop();
    });
    this._game.physics.enable(this._points, Phaser.Physics.ARCADE);
    this._points.bringToTop();
    this._points.alpha = 0;
  }
  restart() {
    // возврат игрока на середину дороги без щита
    this._game.tweens.removeFrom(this.item);
    this._resetVelocity();
    this.item.body.immovable = true;
    this._currentVelocity = this._defaultVelocity;
    this.item.angle = 0;
    this.item.x = this._coordX;
    this.item.y = this._coordY;
  }
  updatePoints() {
    this._playerData.power -= DELTA_POWER; // отнимаем единицу энергии каждую секунду
    this._playerData.points += this._playerData.pointsMultipler * DELTA_POINTS; // добавляем очки каждую секунду
  }
  stop(collision) {
    if (collision) {
      this._drift();
    }
    this._resetVelocity();

    ANIMATIONS.forEach((item) => {
      this._deactivateAnimation(item);
    });
    if (Object.keys(this._pointsTween).length !== 0) {
      this._deactivatePoints(true);
    }
  }
  /*
   * Shield functions
   */
  get _shieldDiameter() {
    return this._defaultDiameter * this._scaleValue;
  }
  _deactivateShield() {
    if (this._shieldActiveAnim.loopCount === SHIELD_ITERATIONS) {
      this._shieldActiveAnim.stop();
      this._shieldActiveAnim.loopCount = 0;
      this._shieldCreateAnim.reversed = true;
      this._shieldCreate.animations.play('shieldCreate');
    }
  }
  _activateShield() {
    this._shieldActiveAnim.loopCount = 0;
    this._shieldCreateAnim.onComplete.add(() => {
      if (!this._shieldCreateAnim.reversed) {
        this._shieldActive.animations.play('shieldActive');
      }
    });
  }
  /*
   * Animation functions
   */
  _activatePoints() {
    this._points.position.y = this._coordY;
    this._pointsTween = this._game.add.tween(this._points).to({ y: this._coordY - (50 * this._scaleValue), alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true);
  }
  _deactivatePoints(stop) {
    if (stop) {
      this._pointsTween.stop();
    }
    if (stop || !this._pointsTween.isRunning) {
      this._pointsTween = {};
      this._points.alpha = 0;
    }
  }
  _deactivateDoublePoints() {
    if (this._playerData.pointsMultipler === 1) {
      this._deactivateAnimation('doublePoints');
    }
  }
  _updateAnimations() {
    if (Object.keys(this._pointsTween).length !== 0) { // если анимация очков активна
      this._points.position.x = this.item.position.x; // двигаем её по x вместе с игроком
      this._points.body.velocity.x = this.item.body.velocity.x; // велосити, чтобы она двигалась без съезжаний
      this._deactivatePoints(false); // убираем анимацию очков, если её время закончилось
    }
    ANIMATIONS.forEach((item) => {
      if (this[`_${item}Anim`].isPlaying) { // если анимация активна
        this._moveAnimation(item); // двигаем её вместе с игроком
        this._deactivateShield(); // убираем щит, если его время закончилось
        this._deactivateDoublePoints(); // убираем анимацию удвоения очков, если её время закончилось
      } else { // если анимация не активна
        this._deactivateAnimation(item); // убираем её за границы экрана и стопаем
      }
    });
  }
  _moveAnimation(name) {
    this[`_${name}`].centerX = this.item.centerX;
    this[`_${name}`].body.velocity.x = this.item.body.velocity.x;
  }
  _deactivateAnimation(name) {
    if (this[`_${name}`].position.x !== -gameConsts.GAME_WIDTH) {
      this[`_${name}`].position.x = -gameConsts.GAME_WIDTH;
      this[`_${name}`].body.velocity.x = 0;
      this[`_${name}Anim`].stop();
    }
  }
  activateAnimation(name) {
    this[`_${name}Anim`].reversed = false;
    this[`_${name}`].animations.play(name);
    this[`_${name}`].centerY = this.item.centerY;
    this._activatePoints();
    if (name === 'shieldCreate') {
      this._activateShield();
    }
  }
}




// WEBPACK FOOTER //
// ./src/js/Player.js